import { useState } from "react";
import Router from "./router";
import { Toaster } from "react-hot-toast";


// ---------------------------- axios config for token
import "./config/axios-config/axios-config";

// context
import Context from "./context/profileContext";

function App() {
  const [profileTitle, changeTitle] = useState("");

  return (
    <Context.Provider value={{ profileTitle, changeTitle }}>
      <Router />
      <Toaster position="top-center" reverseOrder={false} />
    </Context.Provider>
  );
}

export default App;
